<template>
  <span class="font-bold" v-if="state.copied">{{ copiedText }}</span>
  <span class="inline-flex flex-row items-baseline gap-xs" v-else>
    <a
      class="font-normal"
      href="#"
      @click.stop.prevent="copyToClipboard"
      data-testid="copy-to-clipboard"
      >{{ text }}</a
    >
    <FontAwesomeIcon
      class="text-text-brand"
      icon="fa-regular fa-copy"
      size="sm"
    />
  </span>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { reactive } from "vue";

type Props = {
  text: string;
  copiedText?: string;
  data: string;
};

const props = withDefaults(defineProps<Props>(), {
  text: "",
  copiedText: "Kopierad",
  data: "",
});

const state = reactive({
  copied: false,
});

library.add(faCopy);

async function copyToClipboard() {
  await navigator.clipboard.writeText(props.data);
  state.copied = true;
  setTimeout(() => {
    state.copied = false;
  }, 5000);
}
</script>
